"use client";

import dynamic from "next/dynamic";
import React from "react";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
const TabNavigator = dynamic(() => import("./tab-navigator"), { ssr: false });
import { MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import { ProductSpecificationByNameResult } from "@/util/query/product-compare-query";
import { CUSTOMER_LEVEL } from "@prisma/client";

type Props = {
    product: MSProductWithFullDetailWithVaraintPreset & { shopCurrency: string },
    productTabNavigator: any; 
    loc: string, 
    text: { [key: string]: string },
    level: CUSTOMER_LEVEL | string;
    shopCurrency: string;
    enableCompareButton: boolean;
    productSpecification: ProductSpecificationByNameResult | undefined;
    priorityContent?: boolean;
    radiusStyle: any;
}

function TabNavigatorLoader(props: Props) {
    const { product, productTabNavigator, loc, text, level, shopCurrency, enableCompareButton, productSpecification, priorityContent, radiusStyle } = props;
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved || priorityContent ? (
        <TabNavigator 
            product={product}
            productTabNavigator={productTabNavigator} 
            loc={loc} 
            text={text}
            level={level}
            shopCurrency={shopCurrency}
            enableCompareButton={enableCompareButton}
            productSpecification={productSpecification}
            radiusStyle={radiusStyle}
        />
    ) : (
        <section>
            <div className="flex flex-col gap-5">
                <div className="flex flex-col gap-5">
                   {productTabNavigator && productTabNavigator.tabNavigationSections && productTabNavigator.tabNavigationSections.length > 0 && productTabNavigator.tabNavigationSections.map((section: any, index: number) => (
                        <div key={index} className="text-sm font-light">
                            <h2 className="text-lg font-semibold">{section.title}</h2>
                            <p>{section.description}</p>
                            {section.tabNavigationComponentValue && section.tabNavigationComponentValue.map((value: any, idx: number) => (
                                <div key={idx} className="mt-2">
                                    <p>{value.description}</p>
                                    {value.valueType === "PRODUCT_LIST" && value.tabNavigatorProductList && value.tabNavigatorProductList.length > 0 && value.tabNavigatorProductList.map((productItem: any, productIndex: number) => (
                                        <div key={productIndex} className="mt-1">
                                            <p>{productItem.displayName}</p>
                                        </div>
                                    ))}

                                    {value.valueType === "SPECIFICATION" && productSpecification && productSpecification.length > 0 && productSpecification.map((spec: any, specIndex: number) => (
                                        <div key={specIndex} className="mt-1">
                                            <p>                                                             
                                                {spec.attributes?.[0]?.displayName || ""}: {spec.specificationValues?.[0]?.attributes?.[0]?.value || ""}
                                            </p>
                                        </div>
                                    ))}
                                </div>                                   
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TabNavigatorLoader;